export default __webpack_public_path__ + "static/media/imagen_guia.a8c15847.png";